import React, { useContext } from "react";
import { LegacyCard as Card, Text, Layout, TextField, FormLayout, Collapsible, BlockStack } from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Description = () => {
  const { BRAND_DESCRIPTION } = constant;
  const {
    description,
    handleChange,
    // learnMore
  } = useContext(BrandingContext);

  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { updatedAt = "" } = brand || {};

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.brandDescription.title")}
        description={cms("section.brandDescription.description")}
      >
        <Card
          title={[
            cms("section.brandDescription.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore("Description", "TODO: ") }]}
        >
          <Card.Section>
            <FormLayout>
              <BlockStack gap="2">{cms("section.brandDescription.description")}</BlockStack>
              <TextField
                id="description"
                placeholder={cms("section.brandDescription.placeHolder.description")}
                value={description}
                multiline={4}
                onChange={(value) => handleChange(BRAND_DESCRIPTION, value, BRAND_DESCRIPTION)}
              />
            </FormLayout>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(Description), {
  feature: constant.STANDARD_BRANDING,
});
